<template>
  <div class="floatbar">
    <ul class="bar center" v-show="scrollTop > 100">
      <li class="item">
        <el-popover placement="left" trigger="hover">
          <img width="250" height="250" src="/static/img/img_wechat.jpg">
          <i class="iconfont icon-erweima" slot="reference"></i>
        </el-popover>
      </li>
      <li class="item">
        <a class="link" target="_blank" href="http://wpa.qq.com/msgrd?v=3&uin=3511748065&site=qq&menu=yes">
          <i class="iconfont icon-kefu"></i>
        </a>
      </li>
      <li class="item" @click="backTop">
        <i class="iconfont icon-zhiding"></i>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'floatbar',
  data () {
    return {
      scrollTop: 0
    }
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll () {
      this.scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
    },
    backTop () {
      const doc = document.body.scrollTop
        ? document.body
        : document.documentElement

      const top = () => {
        let scrollTop = doc.scrollTop

        scrollTop = scrollTop + (0 - scrollTop) / 5

        // 临界判断，终止动画
        if (scrollTop < 1) {
          doc.scrollTop = 0
          return
        }
        doc.scrollTop = scrollTop
        // 动画
        requestAnimationFrame(top)
      }
      top()
    }
  }
}
</script>

<style lang="less" >
@primary: #23a07b;

.floatbar {
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  display: flex;
  align-items: center;
  z-index: 999;
  .bar {
    width: 50px;
    height: 150px;
    display: flex;
    flex-direction: column;
    border: 1px solid #ccc;
    border-radius: 10px;
    background-color: #fff;
    .item {
      width: 50px;
      height: 50px;
      text-align: center;
      line-height: 50px;
      border-top: 1px solid #ccc;
      color: #666;
      &:hover {
        cursor: pointer;
        color: @primary;
      }
      &:first-child {
        border: none;
      }
      .iconfont {
        display: block;
        width: 100%;
        height: 100%;
        font-size: 22px;
      }
      .link {
        display: block;
        width: 100%;
        height: 100%;
      }
    }
  }
}

//  小屏幕不显示
@media screen and (max-width: 768px) {
  .floatbar {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/FloatBar.vue